import DOMPurify from 'dompurify';
import {marked} from 'marked';
import React, {ReactElement} from 'react';
import ReactDOMServer from 'react-dom/server';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface NotificationProps {
  type: string;
  message: string | ReactElement;
  closeable: boolean;
}

function Notification({type, message, closeable}: NotificationProps): JSX.Element {
  let innerHTML =
    typeof message === 'string'
      ? DOMPurify.sanitize(marked(message))
      : ReactDOMServer.renderToStaticMarkup(message);

  // Hack: We can't use dangerouslySetInnerHTML to inject sibling elements, so add the close button
  // by pre-rendering to a string and prepending to the message HTML .
  if (closeable) {
    innerHTML =
      ReactDOMServer.renderToStaticMarkup(
        <button type="button" data-dismiss="alert" className="close">
          &times;
        </button>
      ) + innerHTML;
  }

  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{__html: innerHTML}}
      className={`alert alert-dismissable alert-${type}`}
    />
  );
}

export default makeDeprecatedJadeStyleTemplate<NotificationProps>(Notification);
